import { AfterViewInit, Component, Input, OnDestroy } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { lastValueFrom } from "rxjs";

import { Lote } from "src/app/models/Lote.model";
import { LoteService } from "src/app/core/services/lote.service";
import { LoteDetalleUrlService } from "src/app/core/services/lote-detalle-url.service";
import { LoteCertificadoService } from "src/app/core/services/lote-certificado.service";
import { FirmaStateService } from "src/app/core/states/firma/firma-state.service";
import { LoteDetalleUrlCoordenadaService } from "src/app/core/services/lote-detalle-url-coordenada.service";
import { LoteCertificado } from "src/app/models/LoteCertificado.model";
import { LoteDetalleUrl } from "src/app/models/LoteDetalleUrl.model";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { LoteDetalleUrlCoordenada } from "src/app/models/LoteDetalleUrlCoordenada.model";
import { LoadingService } from "src/app/core/services/loading.service";
import { HelpToursService } from "src/app/core/tours/help-tours.service";

@Component({
  selector: "asociacion-firma-documento",
  templateUrl: "./asociacion-firma-documento.component.html",
  styleUrls: ["./asociacion-firma-documento.css"],
})
export class AsociacionFirmaComponent implements AfterViewInit, OnDestroy {
  @Input() readonly: boolean = false;

  private idLote: any = null;
  private lote: Lote;
  public loteDetalleUrls: LoteDetalleUrl[] = [];
  public documentPdfUrl: SafeResourceUrl | null = null;
  public loteCertificados: LoteCertificado[] = [];
  public loteDetalleUrlId: number;
  public certificado = [];
  public listCertificados: LoteDetalleUrlCoordenada[] = [];
  public estado: string;
  public documentIsLoading: boolean;
  public es_grupo: boolean;
  public usa_plantilla: boolean;
  // Toast
  toast = Swal;

  public findAllCount = 0;
  public countSig = 0;

  constructor(
    private loteDetalleUrlService: LoteDetalleUrlService,
    private firmaStateService: FirmaStateService,
    private loteCertificadoService: LoteCertificadoService,
    private LoteDetalleUrlCoordenadaService: LoteDetalleUrlCoordenadaService,
    private LoteService: LoteService,
    private sanitizer: DomSanitizer,
    public loading: LoadingService,
    private tours: HelpToursService,
  ) {}

  ngOnDestroy(): void {
    this.tours.stop();
  }

  ngAfterViewInit(): void {
    this.onHelp(false);
  }

  async ngOnInit() {
    this.toastAlert();
    await this.estadoFirma();
    this.idLote = this.lote?.id;
    await this.findAllCoordenadas();
    await this.indexLoteDetalleUrl();
    await this.indexLoteCertificado();
    this.countSignature();
  }

  onHelp(force = false) {
    this.tours.start("areas_firma_plantilla_help", force);
  }

  async indexLoteDetalleUrl() {
    let response = null;
    if (!this.es_grupo) {
      response = await lastValueFrom(
        this.loteDetalleUrlService.indexDetalleUrl(this.idLote),
      );
      this.loteDetalleUrls = response.body as LoteDetalleUrl[];
    } else {
      const ids_detalle_url = await this.loteDetalleGrupo();
      const response = await lastValueFrom(
        this.loteDetalleUrlService.indexDetalleUrlGrupo(
          this.idLote,
          ids_detalle_url,
        ),
      );
      this.loteDetalleUrls = [response.body] as LoteDetalleUrl[];
    }
  }

  /*PARA LISTAR URLS POR RUPOOO*/
  async loteDetalleGrupo() {
    let params = new HttpParams();
    const result = await lastValueFrom(
      this.loteDetalleUrlService.loteDetalleGrupo(this.idLote, params),
    );
    return result.body[0].id_detalle_url_login;
  }

  async indexLoteCertificado() {
    const response2 = await lastValueFrom(
      this.loteCertificadoService.indexLoteCertificadoGrupo(this.idLote),
    );
    this.loteCertificados = response2.body as LoteCertificado[];
    // email: x.usuario.email,
    this.certificado = this.loteCertificados.map((x: any) => {
      return {
        id_certificado: x.certificado ? x.certificado.id : "",
        id_grupo: x.id_grupo ? x.id_grupo : "",
        name: x.nombre,
        es_grupo: x.es_grupo,
        firmar_con_imagen: x.firmar_con_imagen,
      };
    });
  }

  async selectDocument(loteDetalleUrlId: number) {
    this.documentIsLoading = true;
    this.loteDetalleUrlId = loteDetalleUrlId;
    this.listCertificado();
    const { body } = await lastValueFrom(
      this.loteDetalleUrlService.showDetalleUrl(
        this.idLote,
        this.loteDetalleUrlId,
      ),
    );
    const base64String = body?.url_documento;

    const dataUrl = `data:application/pdf;base64,${base64String}`;
    this.documentPdfUrl = this.convertBase64ToUrl(dataUrl);

    this.documentIsLoading = false;
  }

  convertBase64ToUrl(base64String: string): string {
    const byteCharacters = atob(base64String.split(",")[1]); // Decodifica Base64 a caracteres binarios
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset++) {
      const byte = byteCharacters.charCodeAt(offset);
      byteArrays.push(byte);
    }

    const byteArray = new Uint8Array(byteArrays);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(blob); // Crea una URL de objeto
    return url;
  }

  async addCertificado(data: any) {
    data.modelo = "Lote";
    data.id_item = this.loteDetalleUrlId;
    let response = "";
    let msg = "";
    /* La primera vez que se valida es_grupo es para ver si es un certificado normal o grupo*/
    if (!data.es_grupo) {
      /* Luego agregamos el valor real que tenemos en nuestro manejador de estado, que se ocupara en el backende*/
      data.es_grupo = this.lote.es_grupo;
      delete data.id_grupo;

      msg = "¡Firmante Guardado!";
      response = await lastValueFrom(
        this.LoteDetalleUrlCoordenadaService.addCoordenadasCertificante(
          this.loteDetalleUrlId,
          data,
        ),
      );
    } else {
      delete data.id_item;
      delete data.id_certificado;
      delete data.es_grupo;
      msg = "¡Grupo Guardado!";
      response = await lastValueFrom(
        this.LoteDetalleUrlCoordenadaService.addCoordenadasGrupo(
          this.loteDetalleUrlId,
          data,
        ),
      );
    }

    if (response) {
      this.listCertificado();
      this.alert("success", msg, "");
    }
  }

  async listCertificado() {
    this.listCertificados = [];
    let response = null;
    if (!this.es_grupo) {
      response = await lastValueFrom(
        this.LoteDetalleUrlCoordenadaService.listDetalleUrlCoordenadas(
          this.loteDetalleUrlId,
        ),
      );
    } else {
      response = await lastValueFrom(
        this.LoteDetalleUrlCoordenadaService.listDetalleUrlCoordenadasGrupo(
          this.loteDetalleUrlId,
        ),
      );
    }

    this.listCertificados = response.body as LoteDetalleUrlCoordenada[];
    if (!this.listCertificados) {
      this.listCertificados = [];
    }
  }

  async deleteCoordenada(coordenada: any) {
    let response = null;
    let msg = "";
    if (this.es_grupo) {
      response = this.deleteCoordenadaGrupo(coordenada);
      msg = "¡Coordenada de grupo elimada!";
    } else {
      response = await lastValueFrom(
        this.LoteDetalleUrlCoordenadaService.deleteCoordenada(
          this.loteDetalleUrlId,
          coordenada.idLoteDetalleCoordenada,
        ),
      );
      msg = "¡Coordenada Eliminada!";
    }

    if (response) {
      this.listCertificado();
      this.alert("success", msg);
    }
  }

  async deleteCoordenadaGrupo(coordenada: any) {
    let id_grupo = coordenada.id_grupo ? { id_grupo: coordenada.id_grupo } : {};
    const response = await lastValueFrom(
      this.LoteService.deleteCoordenadaGrupo(this.lote.id, id_grupo),
    );
    return response;
  }

  async validStatusFirma() {
    await this.findAllCoordenadas();

    if (this.countSig != this.findAllCount) {
      this.alert(
        "warning",
        "Faltan coordenadas",
        "Debe asignar todas las coordenadas antes de firmar el sobre.",
      );
      return false;
    }

    const result = await Swal.fire({
      title: "¡Confirmar coordenadas!",
      text: "Valida que las coordenadas estan en la posición correcta, ya que este paso no se puede revertir.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, Confirmo",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      await this.cambioEstado();
      return true;
    }

    return false;
  }

  async cambioEstado() {
    const response = await lastValueFrom(
      this.LoteService.cambioEstado(this.idLote, { nombre_corto: "SDF" }),
    );

    if (response) {
      this.firmaStateService.updateLote(response as Lote);
      this.estadoFirma();

      this.alert(
        "success",
        "Las coordenadas han sido confirmadas exitosamente",
      );
    }
  }

  async estadoFirma() {
    this.lote = this.firmaStateService.getCurrentState()?.lote;
    this.es_grupo = this.lote.es_grupo;
    this.usa_plantilla = this.lote.firma_por_plantilla;
    this.estado = this.lote.estado?.nombre_corto;
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }

  countSignature() {
    let countCert = this.certificado.length;
    let countDoc = this.loteDetalleUrls.length;
    let countCertNoGrupo = 0;

    if (!this.es_grupo) {
      this.countSig = countCert * countDoc;
    } else {
      countCert = this.countGrupo();
      countCertNoGrupo = this.countNoGrupo();

      this.countSig = countCert + countCertNoGrupo * countCert;
    }
  }

  async findAllCoordenadas() {
    const response = await lastValueFrom(
      this.loteDetalleUrlService.findAllCoordenadas(this.idLote),
    );
    this.findAllCount = response.body.length;
  }

  countGrupo() {
    const cantidadGrupo =
      Number(
        (this.loteCertificados as any[]).find((x) => x.es_grupo === true)
          ?.cantidad,
      ) || 0;
    return cantidadGrupo;
  }

  countNoGrupo() {
    const totalNoGrupo = this.loteCertificados.reduce(
      (acc: number, x: any) => acc + (x.es_grupo ? 0 : 1),
      0,
    );

    return totalNoGrupo;
  }
}
